// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__10fcZ","content":"LayoutSettings_content__3YsHM"};